import { Component } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";
import { SharedModule } from "@shared/shared.module";

@Component({
	selector: "app-terms-and-conditions",
	imports: [
		SharedModule,
		TranslatePipe
	],
	templateUrl: "./terms-and-conditions.component.html",
	styleUrl: "./terms-and-conditions.component.scss",
})
export class TermsAndConditionsComponent { }